// Tripadvisor.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const Tripadvisor = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    es: "https://www.tripadvisor.com/Hotel_Review-g580282-d7392368-Reviews-Iberostar_Cala_Millor-Cala_Millor_Majorca_Balearic_Islands.html?lang=es",
    en: "https://www.tripadvisor.com/Hotel_Review-g580282-d7392368-Reviews-Iberostar_Cala_Millor-Cala_Millor_Majorca_Balearic_Islands.html?lang=en",
    de: "https://www.tripadvisor.com/Hotel_Review-g580282-d7392368-Reviews-Iberostar_Cala_Millor-Cala_Millor_Majorca_Balearic_Islands.html?lang=de",
    fr: "https://www.tripadvisor.com/Hotel_Review-g580282-d7392368-Reviews-Iberostar_Cala_Millor-Cala_Millor_Majorca_Balearic_Islands.html?lang=fr",
    pt: "https://www.tripadvisor.com/Hotel_Review-g580282-d7392368-Reviews-Iberostar_Cala_Millor-Cala_Millor_Majorca_Balearic_Islands.html?lang=pt",
    nl: "https://www.tripadvisor.com/Hotel_Review-g580282-d7392368-Reviews-Iberostar_Cala_Millor-Cala_Millor_Majorca_Balearic_Islands.html?lang=nl",
  };

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button className="full-width-button" onClick={() => setShowModal(true)}>
        <i className="fa fa-tripadvisor icon-adjusted" />
        Tripadvisor
      </button>
      {showModal && (
        <LanguageModal
          title="Tripadvisor"
          icon="fa fa-tripadvisor"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Tripadvisor;
